/* eslint-disable @typescript-eslint/no-explicit-any */
import { put, select, takeLatest } from 'redux-saga/effects';
import {
  APP_INIT_SAGA,
  APP_INIT_COMPLETE,
  appInitialStatusCompleted
} from '../reducers/app';

import { getAppSettings } from '../utils/storage';

import { initCBXClient } from '../web-socket/client';

import { authenticate } from '../web-socket/requests';

import { debug, exception, error } from '../utils/logger';

function* appInitHandler(action: any) {
  // @ts-ignore
  const appSettings = yield getAppSettings();

  debug('App is initializing', { appSettings, action });
  // @ts-ignore
  const state = yield select((s) => s);
  try {
    const { wsUrl, boothId, boothSecret } = appSettings;
    // wsUrl now always resolves (same-origin default), so it is no longer a
    // proxy for "this booth is provisioned". Without credentials the server
    // rejects device-connect with missing-credentials and closes, and the
    // client reconnects on a 2s timer forever — one warning per attempt in the
    // server log. Stay off the socket until someone fills in /settings.
    if (wsUrl && boothId && boothSecret) {
      const cbxSocketClient = initCBXClient(
        wsUrl,
        appSettings.boothId,
        appSettings.boothSecret
      );
      cbxSocketClient.afterOpen(() => {
        cbxSocketClient.send(
          authenticate(appSettings.boothId, appSettings.boothSecret)
        );
      });
      cbxSocketClient.onError(() => {
        error('Error opening cbx web socket');
      });
      yield cbxSocketClient.open();
      debug('CBX socket opened');
    } else {
      debug('Booth not provisioned; skipping connect', { wsUrl, boothId });
      yield put(appInitialStatusCompleted());
    }
  } catch (e) {
    yield put(appInitialStatusCompleted());

    if (window.location.pathname !== '/settings') {
      console.error('Redirect to /settings');
      // history.replace('/settings');
    }
    exception('Error while app init saga', e);
  } finally {
    debug('App is init complete', { state });

    yield put({ type: APP_INIT_COMPLETE });
  }
}

function* appInitComplete() {
  yield put({ type: APP_INIT_COMPLETE });
}

export function* appInitSaga() {
  yield takeLatest(APP_INIT_SAGA, appInitHandler);
}

export function* wsErrorSaga() {
  yield takeLatest('ws/error/cbx', appInitComplete);
}
